<template>
  <v-app id="sanne">
    <v-main>
      <v-container fluid>
        <v-row no-gutters>
          <v-col>
            <div class="ml-2 mb-4" style="font-weight: 600; font-size: large;">Please select the period from which to get the applicants</div>
          </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="1" class="pa-2">
                <date_picker label="From appl. date"                                 
                              :date="hsabFromDate"
                              :startDate="hsabFromDate"
                              field="hsabFromDate" 
                              icon="mdi-calendar-month-outline"
                              :manual="true" 
                              @updateData="updateData"/> 
            </v-col>
            <v-col cols="1" class="pa-2 ml-8">
                <date_picker label="Until appl.date"                                 
                              :date="hsabUntilDate"
                              :startDate="hsabFromDate"
                              field="hsabUntilDate" 
                              icon="mdi-calendar-month-outline"
                              :manual="true" 
                              @updateData="updateData"/>                                      
            </v-col>
        </v-row>
        <v-row dense class="mt-3 pa-2">
            <v-col cols="1">
                <btn_create_excel 
                  :report_program="report" 
                  :report_request="report_request" 
                  :report_params="{from: this.hsabFromDate, until: this.hsabUntilDate}"
                  :show_progress="true" />
            </v-col>
        </v-row>
      </v-container>
    </v-main>
    <navBar title="Ares - Marketing" :home="true" type="marketing" />
  </v-app>
</template>

<script>

import navBar from "@/components/ui/navbars/navbar.vue";
import date_picker from '@/components/ui/date_picker.vue';
import btn_create_excel from "@/components/ui/buttons/btn_create_excel.vue";

 export default {
  components: {
    navBar,
    date_picker,
    btn_create_excel,
  },
  data() {
    return {
      hsabFromDate: null, 
      hsabUntilDate: null,
      report: "ares/json/ares/task/excel/tmp/ovrzwinaction1.p",
      report_params: {},
      report_request: "ovrzwinaction1",          
    }
  },
  created() {
  },
  methods: {
    updateData(data){
      this[data.field] = data.value;
    },
  }
};

</script> 
